// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

let VUE_APP_WS_URL = `wss://${location.hostname}/ws?type=user`


let openPlantGrass = '-openPlantGrass-'

// 网络接口修改此字符 小程序域名要求https
// let httpApi = 'http://192.168.1.2:8828' //测试
// 聊天接口修改此字符 小程序聊天要求wss 例如：wss://mer.crmeb.net

let httpApi,wsApi;
if (process.env.NODE_ENV === 'development') {
	httpApi = 'http://192.168.1.188:8828'
	wsApi='ws://192.168.1.188:8828';
}
module.exports = {
	// 请求域名 格式： https://您的域名







	//H5接口是浏览器地址
	HTTP_REQUEST_URL: httpApi || window.location.protocol + "//" + window.location.host,
	// 聊天长连接地址
	VUE_APP_WS_URL: wsApi ? `${wsApi}/ws?type=user` : VUE_APP_WS_URL,

	openPlantGrass: openPlantGrass,
	HEADER: {
		'content-type': 'application/json',

		'Form-type': navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1 ? 'wechat' : 'h5',







	},
	// 回话密钥名称 请勿修改此配置
	TOKENNAME: 'X-Token',
	// 缓存时间 0 永久
	EXPIRE: 0,

};